import styled from "styled-components/macro";
import {
  MdArrowBackIosNew,
  MdArrowForwardIos,
  MdCheck,
  MdImage,
  MdMenu,
  MdPauseCircleFilled,
  MdPlayCircleFilled,
} from "react-icons/md";
import React, { useEffect, useRef, useState } from "react";
import "../styles/Checkout.css";
import Topnav from "../components/Topnav";
import { useNavigate, useParams } from "react-router";
import Footer from "../components/Footer";
import { formatEuroCents } from "../functions/formatEuroCents";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripeCheckoutForm from "../components/StripeCheckoutForm";
import { isEmpty } from "../functions/isEmpty";
import Spinner from "../components/Spinner";

export default function Checkout({
  products,
  cart,
  setCart,
  reviews,
  isMobile,
  language,
  setLanguage,
  texts,
  apiURL,
  userID,
}) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [cart_value, setCart_value] = useState(0);
  const [summarized_cart, setSummarizedCart] = useState([]);
  const [billingSame, setBillingSame] = useState(true);

  useEffect(() => {
    const summaryMap = new Map();

    cart.forEach((product) => {
      const priceInCents = Number(product.price); // <-- sicherstellen, dass es eine Zahl ist

      if (summaryMap.has(product.id)) {
        const existing = summaryMap.get(product.id);
        existing.count += 1;
        existing.price_all += priceInCents; // Cent summieren
      } else {
        summaryMap.set(product.id, {
          id: product.id,
          name: product.name,
          price: priceInCents, // auch hier Zahl
          count: 1,
          price_all: priceInCents,
          images: product.images,
          description: product.description,
        });
      }
    });

    setSummarizedCart(Array.from(summaryMap.values()));
  }, [cart]);

  useEffect(() => {
    let count = 0;
    cart.forEach((cartItem) => {
      count += Number(cartItem.price); // <-- String -> Zahl
    });
    setCart_value(count);
  }, [cart]);

  function updateCart(productId, action, cart, setCart) {
    if (action === "increase") {
      // Finde das erste Produkt mit der passenden ID (wir nehmen es als Referenz zum Klonen)
      const productToAdd = cart.find((p) => p.id === productId);
      if (productToAdd) {
        setCart([...cart, { ...productToAdd }]);
      }
    } else if (action === "decrease") {
      // Letztes Vorkommen des Produkts finden
      const indexToRemove = [...cart].map((p) => p.id).lastIndexOf(productId);
      if (indexToRemove !== -1) {
        const newCart = [...cart];
        newCart.splice(indexToRemove, 1);
        setCart(newCart);
      }
    }
  }

  /* stripe*/

  const [clientSecret, setClientSecret] = useState(null);
  const [payment_id, setPayment_id] = useState(null);
  const [orderData, setOrderData] = useState({});

  const shoppingCard = cart || [];

  useEffect(() => {
    if (!isEmpty(cart)) {
    } else {
      navigate("/");
    }
  }, [cart]);

  useEffect(async () => {
    if (!isEmpty(cart)) {
      let shoppingCard = [];
      cart.map((item) => {
        shoppingCard.push(item);
      });

      const resa = await fetch(`${apiURL}/stripe/clientsecret.php`, {
        method: "POST",
        headers: {
          //   Authorization: `Bearer ${authToken?.JWT}`,
          "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body: JSON.stringify({
          shoppingCard: shoppingCard,
        }),
      });

      await resa.text().then((value) => saveSecret(value));
    }
  }, [cart]);

  const saveSecret = (data) => {
    setClientSecret(JSON.parse(data).clientSecret);
    setPayment_id(JSON.parse(data).payment_id);
  };

  const stripePromiseTest = loadStripe(
    "pk_test_51Nc4qsGgDkyV2jPHM1mp2JE4ojdrFAi044x1mnUdamHfjCXnogAjdgVqK7sLBW3T5XfPUC6PR88A8xRp4ysQoBcL00XpxBwwez"
  );

  const stripePromiseLive = loadStripe(
    "pk_live_51Nc4qsGgDkyV2jPHjblUn0cXBDbSJk2mszCH8wWb1qKYdMSniNHC8yQV8c5lni4EzTG24omdCRQ2tM3sMIeelFIV00AXmWB0AN"
  );

  // Warte, bis das clientSecret geladen ist
  if (!clientSecret) {
    return (
      <div className="checkout_loading">
        <Spinner size="large" />
      </div>
    );
  }

  return (
    <div className="checkout">
      <div className="home_banner">
        {language == "Deutsch" ? texts.de.banner : texts.en.banner}{" "}
      </div>

      <div className="checkout_section">
        <div className="checkout_section_hero">
          <div className="checkout_section_hero_left">
            <div
              className="checkout_section_hero_left_backbutton"
              onClick={() => navigate("/cart")}>
              <ArrowBackIcon /> Zurück
            </div>
            <div className="checkout_section_hero_left_title">
              Deine Bestellung
            </div>
            <div className="checkout_section_hero_left_products">
              {summarized_cart.map((product, index) => (
                <div className="checkout_section_hero_left_products_product">
                  <div className="checkout_section_hero_left_products_product_firstcol">
                    <div className="checkout_section_hero_left_products_product_firstcol_imgbox">
                      <img
                        src={JSON.parse(product.images)[0]}
                        className="checkout_section_hero_left_products_product_firstcol_imgbox_img"
                      />
                    </div>
                    <div className="checkout_section_hero_left_products_product_firstcol_textbox">
                      <div className="checkout_section_hero_left_products_product_firstcol_textbox_top">
                        {product.name}
                      </div>
                      <div className="checkout_section_hero_left_products_product_firstcol_textbox_bottom">
                        {product.description}
                      </div>
                    </div>
                  </div>
                  <div className="checkout_section_hero_left_products_product_secondcol">
                    <div className="checkout_section_hero_left_products_product_secondcol_top">
                      {product.count + " x " + formatEuroCents(product.price)}{" "}
                    </div>
                    <div className="checkout_section_hero_left_products_product_secondcol_bottom"></div>
                  </div>
                </div>
              ))}
            </div>
            <div className="checkout_section_hero_left_summary">
              <div className="checkout_section_hero_left_summary_firstcol">
                <div className="checkout_section_hero_left_summary_firstcol_deliverycosts">
                  Versand
                </div>
                <div className="checkout_section_hero_left_summary_firstcol_total">
                  Gesamtsumme
                </div>
              </div>
              <div className="checkout_section_hero_left_summary_secondcol">
                <div className="checkout_section_hero_left_summary_secondcol_deliverycosts">
                  0€
                </div>
                <div className="checkout_section_hero_left_summary_secondcol_total">
                  {formatEuroCents(cart_value)}
                </div>
              </div>
            </div>
          </div>
          <div className="checkout_section_hero_right">
            <Elements stripe={stripePromiseTest} options={{ clientSecret }}>
              <StripeCheckoutForm
                isMobile={isMobile}
                apiURL={apiURL}
                //   authToken={authToken}
                order={cart}
                payment_id={payment_id}
                cart={cart}
                userID={userID}
                billingSame={billingSame}
                setBillingSame={setBillingSame}
              />
            </Elements>
          </div>
        </div>
      </div>
      <Footer texts={texts} language={language} />
    </div>
  );
}
const PlayIcon = styled(MdPlayCircleFilled)`
  font-size: 90px;
  color: #ffffff;
  margin-left: -8px;
  margin-top: -12px;
`;

const PauseIcon = styled(MdPauseCircleFilled)`
  font-size: 90px;
  color: #ffffff;
  margin-left: -8px;
  margin-top: -12px;
`;

const ArrowBackIcon = styled(MdArrowBackIosNew)`
  font-size: 20px;
  color: #004a78;
`;

const CheckIcon = styled(MdCheck)`
  font-size: 20px;
  color: #004a78;
`;
